/* mos-task07.js — Task 07 "Let the Reviews Sell"
 *
 * Product page only (loaded from snippets/product-first-screen.liquid).
 * Two display-only enhancements — NO pricing/subscription logic is changed,
 * Seal still controls the real charge at checkout:
 *
 *   1. Subscription price visible — the Seal radios ("רכישה חד פעמית" /
 *      "עשו מנוי קבוע וחסכו X%") ship with no price. We read the current
 *      variant price and the discount % that Seal itself prints in the
 *      subscription label, then render the one-time price and the discounted
 *      renewal price next to each radio.
 *   2. 15% saving made prominent — the plain-text "חסכו 15%" is wrapped in a
 *      visible savings pill (styled in mos-task07.css) instead of hiding in a
 *      faint line.
 *   3. Proof by the buy button — a compact "★ 4.6 · N ביקורות מאומתות" line is
 *      mirrored from the Yotpo bottomline and placed just above Add-to-cart.
 *
 * Everything is guarded: if we cannot parse a clean base price or discount we
 * inject nothing (never show a wrong number).
 */
(function () {
  'use strict';

  var PRICED = 'data-mos-t07-priced';
  var PROOF = 'data-mos-t07-proof';

  // ---- helpers ---------------------------------------------------------

  // Base price of the currently selected variant, in agorot (integer).
  function basePriceAgorot() {
    // Preferred: the variant picked in the product form.
    var idInput = document.querySelector(
      'form[action*="/cart/add"] [name="id"], form[action^="/cart/add"] [name="id"]'
    );
    var meta = window.meta && window.meta.product;
    if (meta && meta.variants && meta.variants.length) {
      var vid = idInput && idInput.value ? String(idInput.value) : null;
      if (vid) {
        for (var i = 0; i < meta.variants.length; i++) {
          if (String(meta.variants[i].id) === vid) return meta.variants[i].price;
        }
      }
      return meta.variants[0].price; // single-variant fallback
    }
    return null;
  }

  // Money formatter that matches the storefront ("212.50 ₪").
  function money(agorot) {
    var n = agorot / 100;
    // No trailing ".00" for whole shekels; two decimals otherwise.
    var s = (Math.round(n * 100) / 100).toFixed(n % 1 === 0 ? 0 : 2);
    return s + ' ₪';
  }

  // Discount percent Seal prints in the subscription label ("...וחסכו 15%").
  function discountPct(container) {
    var txt = container.textContent || '';
    var m = txt.match(/(\d{1,2}(?:\.\d+)?)\s*%/);
    return m ? parseFloat(m[1]) : null;
  }

  // ---- 1 + 2: prices on the Seal radios --------------------------------

  function priceSeal() {
    var containers = document.querySelectorAll('.sealsubs-container');
    if (!containers.length) return;
    var base = basePriceAgorot();
    if (!base || base <= 0) return;

    containers.forEach(function (c) {
      if (c.getAttribute(PRICED) === String(base)) return; // already done for this price

      var pct = discountPct(c);
      var opts = c.querySelectorAll('.sls-option-container');
      if (!opts.length) return;

      opts.forEach(function (opt) {
        var input = opt.querySelector('input.sls-option');
        var label = opt.querySelector('.sls-label-container') || opt;
        if (!label) return;

        // Clean any earlier injection so variant changes re-price correctly.
        var old = label.querySelector('.mos-t07-price');
        if (old) old.remove();

        var isSub = input && input.value === 'subscription';
        var priceAgorot = base;
        if (isSub && pct != null) priceAgorot = Math.round(base * (100 - pct) / 100);

        var wrap = document.createElement('span');
        wrap.className = 'mos-t07-price' + (isSub ? ' mos-t07-price--sub' : '');

        var amount = document.createElement('span');
        amount.className = 'mos-t07-amount';
        amount.textContent = money(priceAgorot);
        wrap.appendChild(amount);

        if (isSub) {
          if (base > priceAgorot) {
            var was = document.createElement('span');
            was.className = 'mos-t07-was';
            was.textContent = money(base);
            wrap.appendChild(was);
          }
          if (pct != null) {
            var save = document.createElement('span');
            save.className = 'mos-t07-save';
            save.textContent = 'חסכו ' + pct + '%'; // "חסכו X%"
            wrap.appendChild(save);
          }
        }
        label.appendChild(wrap);
      });

      c.setAttribute(PRICED, String(base));
    });
  }

  // ---- 3: proof line next to the buy button ----------------------------

  function proof() {
    if (document.querySelector('[' + PROOF + ']')) return; // already placed

    // Read the aggregate from Yotpo's own accessible summary. Its aria-label
    // is the reliable source, e.g.:
    //   "דירוג 4.6 מתוך 5 כוכבים מבוסס על 193 ביקורות. עבור לביקורות."
    var bl = document.querySelector('.yotpo-sr-bottom-line-summary[aria-label], [aria-label*="מתוך 5"]');
    var aria = bl ? bl.getAttribute('aria-label') : '';
    var rating = (aria.match(/([\d.]+)\s*מתוך/) || [])[1];    // "4.6"
    var count = (aria.match(/על\s+([\d,]+)\s+ביקורות/) || [])[1]; // "193"
    if (!rating || !count) return;
    count = count.replace(/,/g, '');

    // The main Add-to-cart button lives outside the cart <form> in this theme.
    // Match the primary buy button by its "…לעגלה" text (quick-add buttons on
    // the page say "…לסל", so they are excluded).
    var atc = [].slice
      .call(document.querySelectorAll('button.btn--primary, button[class*="btn--primary"]'))
      .filter(function (b) { return /לעגלה/.test(b.innerText || ''); })[0];
    if (!atc) return;

    var line = document.createElement('div');
    line.className = 'mos-t07-proof';
    line.setAttribute(PROOF, '1');
    line.innerHTML =
      '<span class="mos-t07-proof__stars">★</span>' +
      '<strong>' + rating + '</strong> · ' +
      count + ' ביקורות מאומתות'; // "N ביקורות מאומתות"
    atc.parentNode.insertBefore(line, atc);
  }

  // ---- shared: current selection + effective price ---------------------

  function selectedIsSub() {
    var r = document.querySelector('.sealsubs-container input.sls-option:checked');
    return !!(r && r.value === 'subscription');
  }
  function currentPct() {
    var c = document.querySelector('.sealsubs-container');
    return c ? discountPct(c) : null;
  }
  // Effective price of the current selection (subscription discount applied).
  function currentPriceAgorot() {
    var base = basePriceAgorot();
    if (!base || base <= 0) return null;
    if (selectedIsSub()) {
      var p = currentPct();
      if (p != null) return Math.round(base * (100 - p) / 100);
    }
    return base;
  }

  // ---- C3: sticky-bar price follows the one-time / subscription choice --

  function stickyPrice() {
    var bar = document.getElementById('cart-bar');
    if (!bar) return;
    var price = currentPriceAgorot();
    if (!price) return;
    var el = bar.querySelector('.cart-bar__product__price');
    if (!el) {
      var info = bar.querySelector('.cart-bar__info');
      if (!info) return;
      el = document.createElement('span');
      el.className = 'cart-bar__product__price';
      info.appendChild(el);
    }
    var key = String(price) + (selectedIsSub() ? 's' : 'o');
    if (el.getAttribute('data-mos-t07-val') === key) return; // no redundant writes (avoids observer loop)
    el.setAttribute('data-mos-t07-val', key);
    el.textContent = money(price);
  }

  // ---- C4: free-shipping line under the Add-to-cart button --------------

  function freeShipLine() {
    if (document.querySelector('[data-mos-t07-freeship]')) return;
    var cfg = window.MOS_T07 || {};
    var limit = cfg.freeShipLimit;
    if (!limit) return;
    var atc = mainAtc();
    if (!atc) return;
    var el = document.createElement('div');
    el.className = 'mos-t07-freeship';
    el.setAttribute('data-mos-t07-freeship', '1');
    el.textContent = 'משלוח חינם מעל ' + limit + ' ₪';
    atc.parentNode.insertBefore(el, atc.nextSibling);
  }

  // ---- C2: subscription terms open inline (no navigating off the page) --

  function subExpander() {
    var links = document.querySelectorAll('.sealsubs-container a, .sls-option-container a, .sls-discount-description a');
    [].forEach.call(links, function (a) {
      if (a.getAttribute('data-mos-t07-sub')) return;
      var t = (a.textContent || '').trim();
      if (!/לפרטים|המנוי|לחצו/.test(t)) return; // only the "plan details" link
      a.setAttribute('data-mos-t07-sub', '1');
      a.setAttribute('role', 'button');
      var panel = document.createElement('div');
      panel.className = 'mos-t07-subterms';
      panel.hidden = true;
      panel.innerHTML =
        (window.MOS_T07 && window.MOS_T07.subTermsHTML) ||
        '<ul>' +
          '<li>חיוב ומשלוח אוטומטיים כל 30 יום</li>' +
          '<li>אפשר להשהות או לבטל בכל עת, ללא התחייבות</li>' +
          '<li>ניהול המנוי דרך חשבון הלקוח או פנייה לשירות</li>' +
        '</ul>';
      a.parentNode.insertBefore(panel, a.nextSibling);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        panel.hidden = !panel.hidden;
      });
    });
  }

  // ---- C1: rotating 5★ proof quotes above the buy button ---------------
  // Quotes come from the product metafield custom.proof_quotes (list of
  // "quote text||First name"), exposed as window.MOS_T07.quotes. If none are
  // set we simply keep the aggregate proof() line — never fabricate reviews.

  function quoteStrip() {
    var cfg = window.MOS_T07 || {};
    var qs = cfg.quotes;
    if (!Array.isArray(qs) || !qs.length) return;
    if (document.querySelector('[data-mos-t07-quotes]')) return;
    var atc = mainAtc();
    if (!atc) return;
    var box = document.createElement('div');
    box.className = 'mos-t07-quotes';
    box.setAttribute('data-mos-t07-quotes', '1');
    function render(i) {
      var parts = String(qs[i]).split('||');
      var text = (parts[0] || '').trim();
      var name = (parts[1] || '').trim();
      box.innerHTML =
        '<span class="mos-t07-quotes__stars" aria-hidden="true">★★★★★</span>' +
        '<span class="mos-t07-quotes__text">“' + text + '”</span>' +
        '<span class="mos-t07-quotes__by">— ' + (name ? name + ' · ' : '') + 'לקוחה מאומתת</span>';
    }
    var idx = 0;
    render(0);
    atc.parentNode.insertBefore(box, atc);
    if (qs.length > 1) {
      setInterval(function () {
        idx = (idx + 1) % qs.length;
        box.classList.add('is-fading');
        setTimeout(function () { render(idx); box.classList.remove('is-fading'); }, 250);
      }, 5000);
    }
  }

  // The primary buy button lives outside the cart <form>; match it by its
  // "…לעגלה" text (quick-add buttons say "…לסל", so they are excluded).
  function mainAtc() {
    return [].slice
      .call(document.querySelectorAll('button.btn--primary, button[class*="btn--primary"]'))
      .filter(function (b) { return /לעגלה/.test(b.innerText || ''); })[0];
  }

  // ---- run + keep in sync ----------------------------------------------

  function run() {
    try { priceSeal(); } catch (e) {}
    try { quoteStrip(); } catch (e) {}
    try { proof(); } catch (e) {}
    try { freeShipLine(); } catch (e) {}
    try { subExpander(); } catch (e) {}
    try { stickyPrice(); } catch (e) {}
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // Seal and Yotpo both render late and re-render on interaction; observe.
  var mo = new MutationObserver(function () { run(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Variant changes (re-price) — Shopify + common theme events.
  ['variant:change', 'variantChange', 'change'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(run, 60); }, true);
  });

  // Safety re-runs while widgets boot.
  [400, 1200, 2500, 5000].forEach(function (ms) { setTimeout(run, ms); });
})();
